import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LoginModule } from './login/login.module';
import { RegistrationModule } from './registration/registration.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlAssessmentModule } from './control-assessment/control-assessment.module';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageModalComponent } from './components/language-modal/language-modal.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NumericValidationService } from './core/services/numericValidation.service';
import { AlphaNumericValidationService } from './core/services/alphanumericValidation.service';
import { RouteConfigLoadStart, Router } from '@angular/router';
import { SubmitConfirmationComponent } from './components/submit-confirmation/submit-confirmation.component';
import { CommonHttpInterceptor } from './core/interceptors/common-http.interceptor';
import { ServerDownComponent } from './components/server-down/server-down.component';
import { ExecutorDashboardModule } from './executor-dashboard/executor-dashboard.module';
import { UnansweredQuestionModalComponent } from './components/unanswered-question-modal/unanswered-question-modal.component';
import { AssessmentModalComponent } from './components/assessment-modal/assessment-modal.component';


@NgModule({
  declarations: [
    AppComponent,
    LanguageModalComponent,
    SubmitConfirmationComponent,
    ServerDownComponent,
    UnansweredQuestionModalComponent,
    AssessmentModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoginModule,
    ControlAssessmentModule,
    ExecutorDashboardModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ModalModule,
    RegistrationModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [BsModalService, NumericValidationService, AlphaNumericValidationService,
    { provide: HTTP_INTERCEPTORS, useClass: CommonHttpInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]

})
export class AppModule {
  constructor(private router: Router) {
    this.router.events.subscribe((x) => {
      if (x instanceof RouteConfigLoadStart && x.route.path === 'registerme') {
        //console.log(x);
        let currentDt = Date.now();
        localStorage.setItem('openpages', currentDt.toString());
        let that = this;
        window.addEventListener('storage', function (e) {
          //console.log('storage evnt: ', e);
          if (e.key == "openpages") {
            // Listen if anybody else is opening the same page!
            localStorage.setItem('page_available', currentDt.toString());

          }
          if (e.key == "page_available") {

            if (x instanceof RouteConfigLoadStart && x.route.path === 'registerme') {
              that.router.navigate(['/invalid-page'], { replaceUrl: true });
            }
          } else {
            if (x instanceof RouteConfigLoadStart && x.route.path === 'registerme') {
              x.route.loadChildren = async () => {
                const m = await import('./registration/registration.module');
                return m.RegistrationModule;
              };
            }
          }
        }, true);
      }
    });
  }
}
